import { useEffect } from 'react';

/**
 * Хук отслеживающий событие beforeunload
 *
 * @param shouldConfirmExit нужно ли спрашивать у юзера подтверждение, что он хочет выйти
 * @param callback функция, которая вызывается при событии beforeunload
 */
export function useOnBeforeUnload(shouldConfirmExit: boolean, callback?: (event: BeforeUnloadEvent) => void) {
    useEffect(() => {
        const beforeunloadListener = (event: BeforeUnloadEvent) => {
            if (callback) {
                callback(event);
            }

            if (shouldConfirmExit) {
                event.preventDefault();
                event.returnValue = true;
            }
        };

        window.addEventListener('beforeunload', beforeunloadListener);
        return () => {
            window.removeEventListener('beforeunload', beforeunloadListener);
        };
    }, [callback, shouldConfirmExit]);
}
